export default {
  props: {
    text: {
      type: String,
      required: true,
    },
    infoOnLeft: {
      type: Boolean,
      default: true,
    },
    selected: Boolean,
  },
  data() {
    return {};
  },
  computed: {
    selectedModifier() {
      return {
        'button-with-info--selected': this.selected,
      };
    },
    iconModifier() {
      return {
        'button-with-info__icon--right': !this.infoOnLeft,
      };
    },
  },
  methods: {
    onClick() {
      this.$emit('click');
    },
    onInfoClick() {
      this.$emit('infoClick');
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/account/history/trades/button-with-info/button-with-info.js